import { Box, List, Text } from '@factorialco/deprecated-design-system'
import { ContractTaxonomyFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import ContractTooltip from 'modules/contracts/components/ContractDetails/ContractTooltip'
import {
  CompensationTypes,
  additionalCompensationType,
  getDescriptionByType,
} from 'modules/contracts/lib/additionalCompensations'
import type Compensation from 'modules/contracts/store/models/Compensation'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  compensation: Compensation
  employee: Employee
  taxonomy?: ContractTaxonomyFragment
}

const CompensationItem = ({ compensation, employee, taxonomy }: Props) => {
  const {
    access: { locale },
  } = useCurrentSession()

  const compensationType = additionalCompensationType(compensation.attributes.compensation_type)
  const isFixed = compensationType === CompensationTypes().fixed?.toLowerCase()

  return (
    <List.Item>
      <Box gap="s8">
        <Box flexDirection="row" gap="s4" alignItems="center">
          <Text size="200" weight="normal" color="grey800">
            {taxonomy?.name ?? ''}
          </Text>
          {isFixed && (
            <Text size="200" weight="normal" color="grey800">
              {compensationType}
            </Text>
          )}
          {compensation.attributes.description && (
            <ContractTooltip
              information={compensation.attributes.description}
              icon="info-circle-line"
            />
          )}
        </Box>
        <Box flexDirection="row" gap="s4">
          <Text.Normal capitalize weight="medium" size="200" color="grey1000">
            {getDescriptionByType(compensation, employee, locale)}
          </Text.Normal>
        </Box>
      </Box>
    </List.Item>
  )
}

export default observer(CompensationItem)
